import { useTranslation } from "react-i18next";
import { useFetchWrapper } from "../hooks/useFetchWrapper";
import { useLoading } from "../utils/LoadingContext";
import {
    formatAPIErrorLog,
    formatAPIResponseLog,
    getFormattedCurrentTime,
    notifyError,
    notifySuccess
} from "../utils/helpers";
import {useConfig} from "../hooks/useConfig";

export const InstitutionApiCalls = () => {
    const { t } = useTranslation();
    const fetchWrapper = useFetchWrapper();
    const config = useConfig();
    const {setLoading} = useLoading();
    return {
        loadInstitution,
        pingInstitution,
        loadInstitutions,
        checkNameExited,
        checkDomainExited,
        saveInstitution,
        listYuJaAccount,
        listEventBanners,
        saveEventBanner,
        deleteEventBanner,
        listTimeZone,
        uploadImg,
        uploadLogoImg,
        saveSSODetails,
        getSSODetails,
        saveLMSConfig,
        getSetting,
        updateSetting,
        questionGenerate,
        batchUpdateAdminManagers,
        getSupportCode,
    }


    function loadInstitution (instId) {
        return fetchWrapper.get({url: `${config.api.institution}/institution/details/${instId}`})
            .then((res) => {
                if (res.success) {
                    return res.result;
                } else {
                    notifyError(res.errorMessage);
                    return null;
                }
            }, (err) => {
                notifyError(t("institution.loadInstitutionsError"));
                console.log(err);
                return null;
            });
    }




    function pingInstitution(shortName) {
    const fullUrl = `https://${shortName}.${config.host_url}`;

        return fetch(fullUrl, {
            mode: 'no-cors',
            cache: 'no-cache'
        }).then(() => {
            return true;
        }).catch(err => {
            return false;
        }) ;

        // return fetchWrapper.put({
        //     url: `${config.api.institution}/institution/${shortName}/ping`,
        // }).then(
        //     (res) => {
        //         if (res.success) {
        //             return res.result;
        //         } else {
        //             console.log(res);
        //             return false;
        //         }
        //     },
        //     (error) => {
        //         console.log(error);
        //         return false;
        //     }
        // ).catch(e => {
        //     console.log(e);
        //     return false;
        // });
    }

    function loadInstitutions () {
        return fetchWrapper.get({url: `${config.api.institution}/institutions`})
            .then((res) => {
                if (res.success) {
                    return res.result;
                } else {
                    notifyError(res.errorMessage);
                    return [];
                }
            }, (err) => {
                notifyError(t("institution.loadInstitutionsError"));
                console.log(err);
                return [];
            });
    }


    function checkDomainExited(shortName) {
        let url = `${config.api.institution}/institution/domain/existed?shortName=${shortName}`
        return fetchWrapper.get({url: url})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                        return null;
                    }
                },
                (error) => {
                    notifyError(t("institution.verifyDomainError"));
                    console.log(error);
                    return null;
                }
            );
    }


    function checkNameExited({fullName, shortName}) {
        let url;
        if (fullName && shortName) {
            url = `${config.api.institution}/institution/existed?fullName=${fullName}&shortName=${shortName}`
        } else if (fullName) {
            url = `${config.api.institution}/institution/existed?fullName=${fullName}`
        } else {
            url = `${config.api.institution}/institution/existed?shortName=${shortName}`
        }

        return fetchWrapper.get({url: url})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                        return true;
                    }
                },
                (error) => {
                    notifyError(t("institution.checkInstitutionError"));
                    console.log(error);
                    // throw new Error(error);

                    return true;
                }
            );
    }


    function saveInstitution(institutionObj, isNew) {
        if (isNew) {
            return fetchWrapper.post({
                url: `${config.api.institution}/institution`,
                body: institutionObj
            }).then(
                (res) => {
                    if (res.success) {
                        return res.success;
                    } else {
                        notifyError(res.errorMessage);
                        console.log(res);
                    }
                    return res.result;
                },
                (error) => {
                    notifyError(t("institution.saveInstitutionsError"));
                    console.log(error);
                    return null;
                }
            ).catch(e => {
                notifyError(t("institution.saveInstitutionsError"));
                console.log(e);
                return null;
            });
        } else {
            return fetchWrapper.put({
                url: `${config.api.institution}/institution/${institutionObj.code}`,
                body: institutionObj
            }).then(
                (res) => {
                    if (res.success) {
                        return res.success;
                    } else {
                        notifyError(res.errorMessage);
                        console.log(res);
                    }
                    return res.success;
                },
                (error) => {
                    notifyError(t("institution.saveInstitutionsError"));
                    console.log(error);
                    return false;
                }
            ).catch(e => {
                console.log(e);
                return false;
            });
        }
    }

    function listYuJaAccount() {
        return fetchWrapper.get({url: `${config.api.institution}/yuja/accounts`})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                        return [];
                    }
                },
                (error) => {
                    notifyError(t("institution.loadYujaAccountError"));
                    console.log(error);
                    return [];
                });
    }


    function listEventBanners() {
        return fetchWrapper.get({url: `${config.api.institution}/eventBanners`})
            .then((res) => {
                    if (res.success) {
                        return res.result.map(b => {
                            b.institutions = !!b.institutions ? b.institutions : [];
                            return b;
                        });
                    } else {
                        notifyError(res.errorMessage);
                        return [];
                    }
                },
                (error) => {
                    console.log(error);
                    return [];
                });
    }

    function saveEventBanner(eventBanner, isCreation=true) {
        let copy = JSON.parse(JSON.stringify(eventBanner));

        if (!copy.hasOwnProperty("institutions")) {
            copy.institutions = [];
        }
        return fetchWrapper.post({
            url: `${config.api.institution}/eventBanner`,
            body: copy
        }).then((res) => {
            if (res.success) {
                notifySuccess(isCreation ? "Successfully created event banner." : "Event banner updated successfully..")
                return true;
            } else {
                notifyError(t("institution.saveEventBannerError"));
                console.log(res);
                return false;
            }
        }).catch(e => {
            notifyError(t("institution.saveEventBannerError"));
            console.log(e);
            return false;
        });
    }

    function deleteEventBanner(id) {
        return fetchWrapper.delete({
            url: `${config.api.institution}/eventBanner/${id}`,
        }).then((res) => {
            if (res.success) {
                notifySuccess(t("institution.eventDeleted"))
                return true;
            } else {
                notifyError(t("institution.deleteEventBannerError"));
                console.log(res);
                return false;
            }
        }).catch(e => {
            notifyError(t("institution.deleteEventBannerError"));
            console.log(e);
            return false;
        });
    }



    function listTimeZone() {
        return fetchWrapper.get({url: `${config.api.institution}/institution/timeZones`})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                    }
                },
                (error) => {
                    notifyError(t("institution.loadTimeZoneError"));
                    console.log(error);
                });
    }


    function uploadImg(file, refreshFunc) {
        const fileName = `${getFormattedCurrentTime()}${getSuffix(file.name)}`;

        const cleanedFileName = removeSpecialCharacters(fileName);
        return fetchWrapper.put({
            url: `${config.api.institution}/institution/bgImg`,
            body: {originalName: cleanedFileName}
        }).then(result => {
            if (result.success) {
                return result.result;
            } else {
                notifyError(result.errorMessage);
                return "";
            }
        }).then(({putURL: url, getURL}) => {
            if (!url) {
                return "";
            }
            const requestOptions = {
                headers: {"Content-Type": file.type},
                method: 'PUT',
                body: file
            };
            return fetch(url, requestOptions).then(res=> {
                if (refreshFunc) {
                    refreshFunc(getURL);
                }
            });
        }).catch(err => {
            console.log(err);
            notifyError(t('common.serverError'));
        });
    }


    function uploadLogoImg(file, refreshFunc) {
        const fileName = `${getFormattedCurrentTime()}${getSuffix(file.name)}`;

        const cleanedFileName = removeSpecialCharacters(fileName);
        return fetchWrapper.put({
            url: `${config.api.institution}/institution/logoImg`,
            body: {originalName: cleanedFileName}
        }).then(result => {
            if (result.success) {
                return result.result;
            } else {
                notifyError(result.errorMessage);
                return "";
            }
        }).then(({putURL: url, getURL}) => {
            if (!url) {
                return "";
            }
            const requestOptions = {
                headers: {"Content-Type": file.type},
                method: 'PUT',
                body: file
            };
            return fetch(url, requestOptions).then(res=> {
                console.log(res);
                if (refreshFunc) {
                    refreshFunc(getURL);
                }
            });
        }).catch(err => {
            console.log(err);
            notifyError(t('common.serverError'));
        });
    }

    function saveSSODetails(configJson, integrationType) {
        return fetchWrapper.put(
            {
                url: `${config.api.institution}/institution/ssoconfig`,
                body: {
                    ssoConfigJsonString: JSON.stringify(configJson),
                    integrationType: integrationType
                }
            }
        ).then((result) => {
            if (result.success) {
                notifySuccess(t('common.updateSuccess', { entity: t('entities.ssoDetails') }));
                return true;
            } else {
                notifyError(result.errorMessage);
                return false;
            }
        }).catch(e => {
            notifyError(t('common.updateSuccess', { entity: t('entities.ssoDetails') }));
            console.log(e);
            return false;
        });
    }

    function getSSODetails() {
        return fetchWrapper.get(
            {
                url: `${config.api.institution}/institution/ssoconfig`,
                authorizeRequired: true
            }
        )
        .then(res => {
            if (res.success) {
                return res.result;
            }
        })
        .catch(err => {
            console.log(err);
            notifyError(t('common.loadError', { entity: t('entities.lmsDetails') }));
        });

    }

    function saveLMSConfig(configJson, integrationType) {
        setLoading(true);
        return fetchWrapper.put(
            {
                url: `${config.api.institution}/institution/lmsconfig`,
                body: {
                    lmsConfigJsonString: JSON.stringify(configJson),
                    integrationType: integrationType
                }
            }
        ).then((result) => {
            if (result.success) {
                notifySuccess(t('common.updateSuccess', { entity: t('entities.lmsDetails') }));
                return true;
            } else {
                notifyError(result.errorMessage);
                return false;
            }
        }).catch(e => {
            notifyError(t('common.updateError', { entity: t('entities.lmsDetails') }));
            console.log(e);
            return false
        }).finally(() => {
            setLoading(false);
        });
    }

    function getSetting() {
        return fetchWrapper.get({
            url: `${config.api.institution}/institutions/platformsetting`,
            authorizeRequired: true
        }).then(res => {
            // console.log(res);
            if (res.success) {
                formatAPIResponseLog("getSetting", res.result);
                return res.result;
            } else {
                return {};
            }
        }).catch(err => {
            console.log(err);
            formatAPIErrorLog("getSetting", err);
            notifyError(t('common.loadError', { entity: t('entities.platformSettings') }));
            return {};
        });
    }

    function updateSetting(setting) {
        return fetchWrapper.put({
            url: `${config.api.institution}/institutions/platformsetting`,
            body: {
                setting: setting,
            }
        }).then((result) => {
            // console.log(result);
            if (!result.success) {
                notifyError(result.errorMessage);
            }
            return result;
        }).catch(error => {
            notifyError(t('common.updateError', { entity: t('entities.platformSettings') }));
            console.log(error);
        });
    }

    function questionGenerate(videoLink, questionType) {
        return fetchWrapper.get({
            url: `${config.api.institution}/institution/question/gen?videoLink=${videoLink}&questionType=${questionType}`,
        }).then((result) => {
            // console.log(result);
            if (result.success) {
                return result.result;
            } else {
                notifyError(result.errorMessage);
                return "";
            }
        }).catch(error => {
            let errorObj = JSON.parse(error.message);
            if (errorObj.errorCode === "Y023") {
                notifyError(t('genAI.invalidIntegrationError'));
            } else if (errorObj.errorCode === "Y024") {
                notifyError(t('genAI.missingCaptionsError'));
            } else if (errorObj.errorCode === "Y025") {
                notifyError(t('genAI.invalidVideoLink'));
            } else if (errorObj.errorCode === "Y026") {
                notifyError(t('genAI.invalidVideoLinkDomain'));
            } else if (errorObj.errorCode === "Y027") {
                notifyError(t('genAI.videoFileTooLarge'));
            } else {
                notifyError(t('genAI.generateQuestionError'));
            }
            console.log(error);
            return "";
        });
    }


    function batchUpdateAdminManagers(userId, grantedInstitutions=[], canceledInstIds=[]) {
        return fetchWrapper.put({
            url: `${config.api.institution}/institution/adminManagers`,
            body: {
                id: userId,
                grantedInstitutions,
                canceledInstIds
            }
        }).then(result => {
            if (result.success) {
                return true;
            } else {
                notifyError(result.errorMessage);
                return false;
            }
        }).catch(error => {
            notifyError(t('common.serverError'));
            console.log(error);
            return false;
        })
    }

    function removeSpecialCharacters(fileName) {
        const regex = /[^a-zA-Z0-9.]+/g;
        return fileName.replace(regex, '');
    }

    function getSuffix(imageName) {
        const regexp = /(.+)(\.\w+)/g;
        return regexp.exec(imageName)[2];
    }


    function getSupportCode () {
        return fetchWrapper.get({url: `${config.api.institution}/institution/supportCode`})
            .then((res) => {
                if (res.success) {
                    return res.result;
                } else {
                    console.error(res.errorMessage);
                    return "0";
                }
            }, (err) => {
                notifyError(t("institution.supportCodeError"));
                console.log(err);
                return "0";
            });
    }
}